import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { companyInfo } from '../data/mockData';
import { useLanguage } from '../contexts/LanguageContext';

const About = () => {
  const { t, isRTL } = useLanguage();

  return (
    <div>
      {/* Hero Section */}
      <div 
        className="relative h-80 bg-cover bg-center"
        style={{ backgroundImage: 'url(https://images.pexels.com/photos/7446988/pexels-photo-7446988.jpeg?w=1920&q=80)' }}
      >
        <div className="absolute inset-0 bg-slate-900 bg-opacity-60 flex items-center justify-center">
          {/* Logo Watermark */}
          <img 
            src="/logo.png" 
            alt="Target Health" 
            className="absolute bottom-6 left-6 w-40 opacity-20"
          />
          <h1 className="text-5xl font-bold text-white z-10">{t.about.title}</h1>
        </div>
      </div>

      {/* Content Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-slate-800 mb-4">
                {isRTL ? t.about.mainTitle : 'TARGET FOR'} <span className="text-cyan-500">{isRTL ? '' : 'HEALTH CONSULTING'}</span>
              </h2>
              <div className="w-24 h-1 bg-orange-500 mb-6"></div>
              <p className="text-slate-700 leading-relaxed mb-4">
                {isRTL ? companyInfo.descriptionArabic : companyInfo.description}
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8 mt-12">
              <div>
                <h3 className="text-2xl font-bold text-slate-800 mb-4">{t.about.ourMission}</h3>
                <p className="text-slate-700 leading-relaxed">
                  {t.about.missionText}
                </p>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-slate-800 mb-4">{t.about.ourVision}</h3>
                <p className="text-slate-700 leading-relaxed">
                  {t.about.visionText}
                </p>
              </div>
            </div>

            <div className="mt-12">
              <h3 className="text-2xl font-bold text-slate-800 mb-6">{t.about.whyChoose}</h3>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="flex items-start gap-3">
                  <CheckCircle2 className="text-cyan-500 flex-shrink-0 mt-1" size={24} />
                  <div>
                    <h4 className="font-bold text-slate-800 mb-1">{t.about.expertTeam}</h4>
                    <p className="text-slate-600 text-sm">{t.about.expertTeamDesc}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <CheckCircle2 className="text-cyan-500 flex-shrink-0 mt-1" size={24} />
                  <div>
                    <h4 className="font-bold text-slate-800 mb-1">{t.about.provenTrack}</h4>
                    <p className="text-slate-600 text-sm">{t.about.provenTrackDesc}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <CheckCircle2 className="text-cyan-500 flex-shrink-0 mt-1" size={24} />
                  <div>
                    <h4 className="font-bold text-slate-800 mb-1">{t.about.comprehensiveServices}</h4>
                    <p className="text-slate-600 text-sm">{t.about.comprehensiveServicesDesc}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <CheckCircle2 className="text-cyan-500 flex-shrink-0 mt-1" size={24} />
                  <div>
                    <h4 className="font-bold text-slate-800 mb-1">{t.about.regulatoryCompliance}</h4>
                    <p className="text-slate-600 text-sm">{t.about.regulatoryComplianceDesc}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <CheckCircle2 className="text-cyan-500 flex-shrink-0 mt-1" size={24} />
                  <div>
                    <h4 className="font-bold text-slate-800 mb-1">{t.about.clientCentered}</h4>
                    <p className="text-slate-600 text-sm">{t.about.clientCenteredDesc}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <CheckCircle2 className="text-cyan-500 flex-shrink-0 mt-1" size={24} />
                  <div>
                    <h4 className="font-bold text-slate-800 mb-1">{t.about.continuousSupport}</h4>
                    <p className="text-slate-600 text-sm">{t.about.continuousSupportDesc}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;